import { render } from "./EmployeeModal.vue?vue&type=template&id=a22e7836&scoped=true"
import script from "./EmployeeModal.vue?vue&type=script&lang=js"
export * from "./EmployeeModal.vue?vue&type=script&lang=js"

import "./EmployeeModal.vue?vue&type=style&index=0&id=a22e7836&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22e7836"]])

export default __exports__